<template>
  <Layout>
    <div class="row">
      <div class="col-md-12 mx-auto">
        <form @submit.prevent="onSubmit" enctype="multipart/form-data">
          <h4 class="mt-2">{{ $t(title) }}</h4>
          <hr />
          <div class="row mt-4">
            <div class="col-md-6">
              <label>{{ $t("pages.roles.name") }} </label>
              <input v-model.trim="roles.name" class="form-control mb-4" required />
            </div>
            <div class="col-md-6">
              <label> Description </label>
              <input v-model.trim="roles.slug" class="form-control mb-4" required />
            </div>
          </div>
          <h4 class="mt-4">{{ $t("pages.roles.permissions") }}</h4>
          <hr />
          <div class="row mt-2" v-if="gettingPermissions">
            <b-skeleton-table :rows="6" :columns="4"></b-skeleton-table>
          </div>
          <div class="row" v-else>
            <div class="col-md-12" v-for="(key, index) in Object.keys(permissions)" :key="index">
              <h4 class="mt-4">{{ $t("pages.roles.groups." + key) }}</h4>
              <div class="row">
                <div class="col-md-3 text-left" v-for="(p, index) in permissions[key]" :key="index">
                  <div class="form-check mt-2" v-if="p != null">
                    <input class="form-check-input" v-model="p.isTrue" type="checkbox" :value="p.id"
                      :id="p.name" />
                    <label class="form-check-label" :for="p.name">
                      {{ $t("pages.roles.rights." + p.slug) }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="mt-4 mb-3">
            <div class="row">
              <div class="col-md-12">
                <button v-if="this.isLoading === false" type="submit" class="btn btn-primary mr-2">
                  {{ $t("pages.users.save") }}
                </button>
                <button class="btn btn-primary mr-2" type="button" v-else disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {{ $t("pages.users.saving") }}
                </button>
                <router-link :to="{ name: 'Roles' }" class="btn btn-light">{{ $t("pages.users.cancel") }}
                </router-link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapActions } from "vuex";
import rolesApi from "../../../api/rolesApi";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "UpdateRole",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      title: "pages.roles.edit",
      items: [
        {
          text: "pages.roles.roles",
        },
        {
          text: "pages.roles.edit",
          active: true,
        },
      ],
      isLoading: false,
      initializing: false,
      gettingPermissions: false,
      roles: {},
      permissions: {},
      temporaryPermissions: {},
      Rolespermissions: {},
    };
  },

  methods: {
    ...mapActions(["updateRole", "getRoles", "groupPermissions"]),
    onSubmit() {
      if (this.$can("update", "roles")) {
        this.isLoading = true;
        Object.keys(this.temporaryPermissions).forEach((key) => {
          this.permissions[key] = this.permissions[key].map((permission) => {
            if (permission.isTrue) {
              return {
                id: permission.id,
                name: permission.name,
                subject: permission.subject,
                slug: permission.slug,
              };
            }
            return null;
          });
        });
        const data = {
          role: this.roles,
          permissions: this.permissions,
          roleId: this.$route.params.id,
        };
        this.updateRole(data)
          .then((response) => {
            if (response.status == 200) {
              this.$toasted.success(this.$t("pages.users.actions.updated"));
              this.isLoading = false;
              this.$router.push({ name: "Roles" });
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.$toasted.error(this.$t("pages.unauthorized.error_0"));
            console.log(err);
          });
      } else {
        this.$toasted.error(this.$t("pages.unauthorized.forbidden_1"));
      }
    },
  },
  created() {
    if (this.$can("update", "roles")) {
      this.initializing = true;
      this.gettingPermissions = true;
      this.groupPermissions(this.$route.params.id)
        .then((response) => {
          if (response.status == 200) {
            this.temporaryPermissions = response.data;
            this.gettingPermissions = false;
            rolesApi
              .show(this.$route.params.id)
              .then((response) => {
                this.initializing = false;
                //this.roles = response.data.roleRead;
                this.Rolespermissions = response.data.permissions;
                this.roles = response.data.roleRead;

                Object.keys(this.temporaryPermissions).forEach((key) => {
                  this.permissions[key] = this.temporaryPermissions[key].map(
                    (permission) => {
                      if (
                        this.Rolespermissions.some(
                          (e) => e.id === permission.id
                        )
                      ) {
                        return {
                          id: permission.id,
                          slug: permission.slug,
                          name: permission.name,
                          subject: permission.subject,
                          isTrue: true,
                        };
                      } else {
                        return {
                          id: permission.id,
                          slug: permission.slug,
                          subject: permission.subject,
                          name: permission.name,
                          isTrue: false,
                        };
                      }
                    }
                  );
                });
                console.log("this", this.permissions);
              })
              .catch((err) => {
                this.initializing = false;
                this.$toasted.error(this.$t("pages.unauthorized.server_error"));
                console.log(err);
              });
          } else {
            this.gettingPermissions = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.gettingPermissions = false;
        });
    }
  },
};
</script>


